import React, { useState } from "react";
import Navbar from "../../../components/navbar/Navbar";
import Footer from "../../../components/footer/Footer";
import FDServices from "./tabs/FDServices";
import InsurancePlans from "./tabs/InsurancePlans";
import SavingsAccount from "./tabs/SavingsAccount";

export default function OurServices() {
  const [activeTab, setActiveTab] = useState("fd");

  return (
    <>
      <Navbar />
      <div className="container mt-5">
        <div className="text-center bg-white p-2 rounded">
          <ul className="nav nav-pills justify-content-center tab-container">
            <li className="nav-item">
              <button
                className={`nav-link tab-item ${activeTab === "fd" ? "active" : ""}`}
                onClick={() => setActiveTab("fd")}
              >
                Fixed Deposit
              </button>
            </li>
            <li className="nav-item">
              <button
                className={`nav-link tab-item ${activeTab === "sa" ? "active" : ""}`}
                onClick={() => setActiveTab("sa")}
              >
                Savings Account
              </button>
            </li>
            <li className="nav-item">
              <button
                className={`nav-link tab-item ${activeTab === "insurance" ? "active" : ""}`}
                onClick={() => setActiveTab("insurance")}
              >
                Insurance
              </button>
            </li>
          </ul>
        </div>

        <div className="tab-content text-center mt-4">
          {activeTab === "fd" && (
            <div className="tab-pane fade show active">
              {/* <h3>Fixed Deposit</h3> */}
              <FDServices />
            </div>
          )}
          {activeTab === "sa" && (
            <div className="tab-pane fade show active">
              {/* <h3>Savings Account</h3>
              <p>Flexible loan options tailored to your financial needs.</p> */}
              <SavingsAccount />
            </div>
          )}
          {activeTab === "insurance" && (
            <div className="tab-pane fade show active">
              <InsurancePlans />
              
            </div>
          )}
        </div>
      </div>
      <Footer />
    </>
  );
}

